<template>
  <router-link
    v-if="routeName"
    :to="{ name: routeName, query: queryParams }"
    class="decoratrion-accent transition-ease-in-out inline-block text-sm font-light text-accent underline hover:opacity-70"
  >
    <slot />
  </router-link>
  <p
    v-else
    class="decoratrion-accent transition-ease-in-out inline-block cursor-pointer text-sm font-light text-accent underline hover:opacity-70"
  >
    <slot />
  </p>
</template>

<script>
import { sanitizeUrl } from "@braintree/sanitize-url";

export default {
  name: "AuthLink",
  props: ["routeName"],
  computed: {
    sanitizeRedirectUrl() {
      return sanitizeUrl(this.$route.query?.redirect);
    },
    isRegisterRoute() {
      return this.routeName === "RegisterPatient";
    },
    queryParams() {
      if (this.sanitizeRedirectUrl !== "about:blank") {
        return {
          redirect: this.sanitizeRedirectUrl,
        };
      }

      return this.isRegisterRoute
        ? { redirect: this.fullRedirectAfterRegisterPath }
        : {};
    },
    fullRedirectAfterRegisterPath() {
      if (this.$route.name === "RegisterPatient") {
        return undefined;
      }

      return `${window.location.origin}${this.$route.href}`;
    },
  },
};
</script>
